import { render, staticRenderFns } from "./delete_blob_modal.vue?vue&type=template&id=345640a8"
import script from "./delete_blob_modal.vue?vue&type=script&lang=js"
export * from "./delete_blob_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports